module.exports = __webpack_public_path__ + "img/img-error-ellipse@2x.6989ea34.png";